import { useTranslation } from 'react-i18next';
import { Spin } from '../Ant';
import MatterRestrictionDialogs from '../dashboard/addTransaction/matterRestrictionDialogs';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useTaskMatterSelect } from './useTaskMatterSelect';

interface TaskMatterSelectProps {
  disabled?: boolean;
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the matter list is only fetched where the field is rendered. It renders the
 * trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const TaskMatterSelect = ({ disabled, onOpenPicker, onClear }: Readonly<TaskMatterSelectProps>) => {
  const { t } = useTranslation();
  const { select, dialogs, isCheckingRestrictions } = useTaskMatterSelect();

  return (
    <>
      <SearchableSelect
        {...select}
        disabled={disabled}
        ariaLabel={t('matter:matter')}
        placeholder={t('matter:selectMatter')}
        searchPlaceholder={t('matter:search')}
        onSearchIconClick={onOpenPicker}
        onClear={onClear}
        data-field="matter"
        data-testid="matter-button"
      />
      <MatterRestrictionDialogs {...dialogs} />
      {isCheckingRestrictions && <Spin fullscreen />}
    </>
  );
};

export default TaskMatterSelect;
